import {
    GET_PUR_REQUEST,
    GET_PUR_SUCCESS,
    GET_PUR_FAILURE,
} from "../const";


const initialState = {
    posts: []
};
const getPurchases = ({ state, posts, page}) => {
    return page !== 1 ? [...state.posts, ...posts.posts] : [...posts.posts];
}
const handlers = {
    [GET_PUR_REQUEST]: (state) => ({ ...state, loading: true }),
    [GET_PUR_SUCCESS]: (state, { payload: { posts, page } }) => ({
        ...state,
        loading: false,
        total: posts.total,
        posts: getPurchases({state, posts, page}),
    }),
    [GET_PUR_FAILURE]: (state) => ({ ...state, loading: false }),
    DEFAULT: (state) => state,
};


const homePurchasesReducer = (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};

export default homePurchasesReducer;